import {nanoid} from 'nanoid';

/**
 * @param {Array} array with objects
 */

export const addIdToArrayObjects = (array = []) => {
    return array?.map((item) => {
        return {
            ...item,
            id: nanoid(),
        };
    });
};
